<div layout="row" layout-align="end">
  <div layout="column" layout-align="end">
    <span class="greeting">{{ getGreeting() }}, {{ operator.firstName }}!</span>
    @if (lastLogin) {
      <div class="login-details">
        <div
          class="message-to-user"
          layout="row"
          layout-align="space-between center"
        >
          <span
            >{{ 'administrators.lastLoginAttemptsMessage' | translate }}:</span
          >
          <span>{{ lastLogin.time | date: 'mediumTime' }}</span>
        </div>
        <div
          class="message-to-user"
          layout="row"
          layout-align="space-between center"
        >
          <span
            [matTooltip]="
              'administrators.unsuccessfulLoginAttemptsCountMessageTooltip'
                | translate: { date: loginHistoryFromDate }
            "
            >{{
              'administrators.unsuccessfulLoginAttemptsCountMessage'
                | translate
            }}:</span
          >
          <span [ngClass]="{ warn: !!failedAttemptsCount }">{{
            failedAttemptsCount
          }}</span>
        </div>
      </div>
    }
  </div>
</div>
